import { render, staticRenderFns } from "./PriceManage.vue?vue&type=template&id=6ac27c43&scoped=true&"
import script from "./PriceManage.vue?vue&type=script&lang=js&"
export * from "./PriceManage.vue?vue&type=script&lang=js&"
import style0 from "./PriceManage.vue?vue&type=style&index=0&id=6ac27c43&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac27c43",
  null
  
)

export default component.exports